import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import { useApplicationRoleManageAccess, useTargetPerson } from 'hooks'
import ApplicationRoleDetails from './ApplicationRoleDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const ApplicationRolesDrawer = ({ attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const query = useQuery()

    const accountId = query.get('accountId')
    const id = query.get('selected')

    const { data } = useApplicationRoleManageAccess(
        id,
        targetPerson.id,
        accountId,
    )

    let item
    if (data) {
        item = {
            resource: data.resource,
            assignment: data.assignment,
        }
    }

    const itemDetails = <ApplicationRoleDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default ApplicationRolesDrawer
